module.exports = __webpack_public_path__ + "img/16k016-07.455917b0.png";